<script setup>;
</script>
<template>

    <Head>
        <title>Listado de inspecciones y verificaciones</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-secretarias-direcciones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Listado de inspecciones y verificaciones</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <div class="col-lg-2 text-center text-md-left mb-4"><img :src="'/storage/' + seccion.imagen" alt="" loading="lazy" /></div>
                    <div class="col-lg-10 contenido-administrable text-center text-md-left" v-html="seccion.descripcion"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-md-8 p-0">
                        <div class="form-group">
                            <select class="form-control form__select" v-model="secretaria">
                                <option value="" :selected="secretaria == ''">Todas las Secretarías</option>
                                <option v-for="(item, i) in secretarias" :key="i" :value="item.id">{{ item.nombre }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 p-0 pl-md-2 pl-lg-2">
                        <button type="button" class="boton-principal boton-flecha">Filtrar</button>
                    </div>
                </div>
                <div class="mt-5">
                    <div class="row">
                        <div class="col-lg-4 col-md-3 col-12 mb-5" v-for="(item, index) in filterBySecretaria(datos)" :key="index">
                            <div class="item">
                                <div class="text p-4">
                                    <img src="/img/mejora/file.png" />
                                    <div class="titulo font-weight-bold">{{ item.nombre }}</div>
                                    <div class="tipo">
                                        <div v-if="item.tipo === 'Inspección'">
                                            <img src="/img/mejora/icon_analisis.png" alt=""/>
                                        </div>
                                        <div v-else-if="item.tipo === 'Verificación'">
                                            <font-awesome-icon icon="fa-solid fa-file-alt" class="mr-1" />
                                        </div>
                                        <div v-else="item.tipo === 'Visita'">
                                            <font-awesome-icon icon="fa-solid fa-house" class="mr-1" />
                                        </div>
                                        {{ item.tipo }}
                                    </div>
                                    <div class="tipo">{{ item.secretaria.nombre }}</div>
                                </div>
                                <div class="action p-3">
                                    <a :href="route('inspecciones.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHouse, faFileAlt } from '@fortawesome/free-solid-svg-icons'
library.add([faHouse, faFileAlt]);
export default {
    data() {
        return {
            secretaria: '',
            modalShow: false,
        }
    },
    props: {
        seccion: Object,
        datos: Object,
        groups: Object,
        secretarias: Object,
    },
    methods: {
        filterBySecretaria: function (datos) {
            return this.secretaria ?
                datos.filter((item) => item.secretaria_id.toString() === this.secretaria.toString())
                : datos;
        },
    },
    compatConfig: { MODE: 3 }
}
</script>
<style scoped>
.bloque-general__encabezado {
    margin-top: 3.125rem;
}

.boton-principal {
    height: 3.125rem;
    padding: .0625rem 1.9375rem;
}

h2 {
    margin-top: 0;
    line-height: 1.3em;
}

.boton-secundario {
    padding: .5rem 1.25rem;
    font-size: 1rem;
}

.item {
    height: 100%;
    font-size: 1.0625rem;
    background: #FFFFFF;
    box-shadow: .125rem .125rem .625rem 0 rgba(0, 0, 0, 0.23);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.item .text {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.item .text .titulo {
    line-height: 1.1em;
    margin-top: 20px;
    text-align: center;
}

.item .text .tipo {
    font-family: "Playfair Display", Georgia, serif;
    font-size: 16px;
    color: #505050;
    text-align: center;
    display: flex;
    align-items: baseline;
    line-height: 1.3em;
    margin-top: 10px;
}

.item .text .tipo img {
    margin-right: 8px;
}

.item .action {
    background: #F9F9F9;
    text-align: center;
}
</style>
